export { FacilitiesCard } from "./landing";
